
import { createRoot } from 'react-dom/client';
import React from 'react';
import App from './App.tsx';
import './index.css';

// Function to register and update service worker
const registerServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', async () => {
      try {
        const registration = await navigator.serviceWorker.register('/sw.js');
        console.log('ServiceWorker registration successful with scope: ', registration.scope);
        
        // Check for updates periodically in development
        if (import.meta.env.DEV) {
          setInterval(() => {
            registration.update();
            console.log('Checking for service worker updates...');
          }, 60000);
        }
        
        // Handle updates
        registration.addEventListener('updatefound', () => {
          const installingWorker = registration.installing;
          if (installingWorker) {
            installingWorker.addEventListener('statechange', () => {
              if (installingWorker.state === 'installed' && navigator.serviceWorker.controller) {
                const shouldUpdate = window.confirm('New version available! Reload to update?');
                if (shouldUpdate) {
                  window.location.reload();
                }
              }
            });
          }
        });
      } catch (error) {
        console.error('ServiceWorker registration failed: ', error);
      }
    });

    // Handle offline/online status
    window.addEventListener('online', () => {
      console.log('Application is online');
    });

    window.addEventListener('offline', () => {
      console.log('Application is offline');
    });
  }
};

// Register service worker
registerServiceWorker();

// Root element rendering
const rootElement = document.getElementById("root");
if (rootElement) {
  createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  console.error("Root element not found!");
}
